/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Value_Ethics_TextInputs */



/**
* | output |
* | --- |
* | "High ethical standards, backed by an operations team that keeps clients well looked after." |
*
* @param {About_Value_Ethics_TextInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const about_value_ethics_text = /** @type {((inputs?: About_Value_Ethics_TextInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Value_Ethics_TextInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("坚守高标准的职业道德，由运营团队悉心照顾每一位客户。")
	return /** @type {LocalizedString} */ ("High ethical standards, backed by an operations team that keeps clients well looked after.")
});